<template>
    <div>
        <vbl-dropdown>
            <vbl-button>请选择</vbl-button>
            <div slot="content">
                <div style="width: 200px;">
                    自定义内容自定义内容自定义内容自定义内容自定义内容
                </div>
            </div>
        </vbl-dropdown>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: false
            };
        }
    }
</script>


// WEBPACK FOOTER //
// vblDropdownExample.vue?5964e1ee